export default "__VITE_ASSET__BtJVHEGZ__"